import RestUtility from '../../restUtility';
import { auth0UserInfoEndPoint } from '../../restUtility/restEndpoints';

export class Auth0UserService {
  private restUtility: RestUtility;

  constructor() {
    this.restUtility = new RestUtility();
  }

  async getAuth0UserInfo() {
    const response = await this.restUtility.get<any>(
      `${auth0UserInfoEndPoint}`
    );
    return response;
  }
}
